import { FiGlobe, FiExternalLink } from "react-icons/fi";
import { BRAND_NAME, COMPANY_LEGAL_NAME, SUPPORT_EMAIL } from "../../constants/brand";
import {
  CONTACT_PHONES,
  SSDI_WEBSITE_LABEL,
  SSDI_WEBSITE_URL,
  SUPPORT_MAILTO_HREF,
  openSupportMail,
} from "../../constants/contact";
import "../../styles/footer.css";

export default function AppFooter() {
  return (
    <footer className="app-footer">
      <div className="app-footer-main">
        <div className="app-footer-glow" aria-hidden />
        <div className="app-footer-inner">
          <p className="app-footer-brand">{BRAND_NAME}</p>
          <div className="app-footer-developer-line">
            <span className="app-footer-developed-label">Developed By  :</span>
            <span className="app-footer-line-sep" aria-hidden>
              ·
            </span>
            <span className="app-footer-company-name">{COMPANY_LEGAL_NAME}</span>
            <span className="app-footer-line-sep" aria-hidden>
              ·
            </span>
            <a
              href={SSDI_WEBSITE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="app-footer-ssdi-link"
            >
              <FiGlobe className="app-footer-globe-icon" aria-hidden />
              {SSDI_WEBSITE_LABEL}
              <FiExternalLink className="app-footer-link-icon" aria-hidden />
            </a>
          </div>

          <div className="app-footer-hrule">
            <span className="app-footer-flare app-footer-flare--left" aria-hidden />
            <span className="app-footer-flare app-footer-flare--right" aria-hidden />
          </div>

          <div className="app-footer-contacts">
            {CONTACT_PHONES.map((phone) => (
              <a key={phone.tel} href={`tel:${phone.tel}`} className="app-footer-phone">
                {phone.label}
              </a>
            ))}
            <a
              href={SUPPORT_MAILTO_HREF}
              className="app-footer-phone"
              onClick={openSupportMail}
            >
              {SUPPORT_EMAIL}
            </a>
          </div>
          <p className="app-footer-copy">
            © {new Date().getFullYear()} {BRAND_NAME}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
